import { BUSINESS_HOURS_TIMEZONE_CHANGE } from '../types'

export default function doBusinessHoursTimeChange(value) {
  return {
    type: BUSINESS_HOURS_TIMEZONE_CHANGE,
    payload: {
      timezone: value,
    },
  }
}
